import { render, staticRenderFns } from "./PaymentsDaysFilter.vue?vue&type=template&id=44f84680&"
import script from "./PaymentsDaysFilter.vue?vue&type=script&lang=js&"
export * from "./PaymentsDaysFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports